module.exports = __webpack_public_path__ + "img/photo.79b30e32.png";